// Настройки вставки пользователя браузера (localStorage, всегда в try/catch): как вставлять гиперссылки.
import type { LinkMode } from './structure';

export function getPref(key: 'links'): LinkMode {
  try {
    const v = localStorage.getItem('sto.paste.' + key);
    if (v === 'text' || v === 'keep' || v === 'sources') return v;
  } catch { /* недоступно */ }
  return 'text';
}

export function setPref(key: 'links', v: LinkMode) {
  try { localStorage.setItem('sto.paste.' + key, v); } catch { /* недоступно */ }
}
